/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * macweb API
 * OpenAPI spec version: 0.4.45
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConnectionMeter,
  ErrorResponse,
  MeterUpdatePayload
} from '.././model';

import { customInstance } from '../../orvalMutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get meter by ID
 */
export const metersGet = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConnectionMeter>(
      {url: `/api/meters/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getMetersGetQueryKey = (id?: number,) => {
    return [
    `/api/meters/${id}`
    ] as const;
    }

    
export const getMetersGetQueryOptions = <TData = Awaited<ReturnType<typeof metersGet>>, TError = ErrorResponse>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metersGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetersGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof metersGet>>> = ({ signal }) => metersGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metersGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetersGetQueryResult = NonNullable<Awaited<ReturnType<typeof metersGet>>>
export type MetersGetQueryError = ErrorResponse


export function useMetersGet<TData = Awaited<ReturnType<typeof metersGet>>, TError = ErrorResponse>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metersGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metersGet>>,
          TError,
          Awaited<ReturnType<typeof metersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetersGet<TData = Awaited<ReturnType<typeof metersGet>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metersGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metersGet>>,
          TError,
          Awaited<ReturnType<typeof metersGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetersGet<TData = Awaited<ReturnType<typeof metersGet>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metersGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get meter by ID
 */

export function useMetersGet<TData = Awaited<ReturnType<typeof metersGet>>, TError = ErrorResponse>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metersGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetersGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Update meter settings
 */
export const metersUpdate = (
    id: number,
    meterUpdatePayload: MeterUpdatePayload,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/meters/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: meterUpdatePayload
    },
      options);
    }
  


export const getMetersUpdateMutationOptions = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metersUpdate>>, TError,{id: number;data: MeterUpdatePayload}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof metersUpdate>>, TError,{id: number;data: MeterUpdatePayload}, TContext> => {

const mutationKey = ['metersUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof metersUpdate>>, {id: number;data: MeterUpdatePayload}> = (props) => {
          const {id,data} = props ?? {};

          return  metersUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MetersUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof metersUpdate>>>
    export type MetersUpdateMutationBody = MeterUpdatePayload
    export type MetersUpdateMutationError = ErrorResponse

    /**
 * @summary Update meter settings
 */
export const useMetersUpdate = <TError = ErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof metersUpdate>>, TError,{id: number;data: MeterUpdatePayload}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof metersUpdate>>,
        TError,
        {id: number;data: MeterUpdatePayload},
        TContext
      > => {

      const mutationOptions = getMetersUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    